import { render, staticRenderFns } from "./headerPerfile.vue?vue&type=template&id=67b0b818&scoped=true&"
import script from "./headerPerfile.vue?vue&type=script&lang=js&"
export * from "./headerPerfile.vue?vue&type=script&lang=js&"
import style0 from "./headerPerfile.vue?vue&type=style&index=0&id=67b0b818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0b818",
  null
  
)

export default component.exports